export default __webpack_public_path__ + "static/media/sun.fbc09220.svg";